import {Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2, RendererStyleFlags2} from '@angular/core';

/**
 * Prevents click if selection has been started
 *
 * @example ```html
 * <div (click.prevent-default)="handleClick($event)">Some selectable content</div>
 * ```
 */
@Directive({
  // tslint:disable-next-line: directive-selector
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[easyAria]'
})
export class EasyAriaDirective implements OnInit, OnDestroy {
  @Input('easyAria') label: string;
  @Input() clickable: string;
  private removeListener: () => void;
  constructor(private renderer: Renderer2, private element: ElementRef) {}

  ngOnInit() {
    this.renderer.setAttribute(this.element.nativeElement, 'aria-label', this.label);
    if (this.element.nativeElement.tagName !== 'BUTTON') {
      this.renderer.setAttribute(this.element.nativeElement, 'tabindex', '0');
      this.renderer.setStyle(this.element.nativeElement, 'outline', 'none', RendererStyleFlags2.Important);
    }
    this.removeListener = this.renderer.listen(this.element.nativeElement, 'keydown', event => {
      if (event.key === ' ') {
        this.element.nativeElement.dispatchEvent(new Event('click'));
        event.preventDefault();
      }
    });
  }

  ngOnDestroy() {
    this.removeListener();
  }
}
